import {BrickContext, Brick, registerBrick, ErrorFlow } from 'olympe';
import * as PDFJS from "pdfjs-dist";

export default class GetPDFPagesCount extends Brick {

    init($){
        PDFJS.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@4.7.76/build/pdf.worker.min.mjs`;
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} pdf
     * @param {function(number)} setPageCount
     * @param {function(ErrorFlow)} setErrorFlow
     */
    async update($, [pdf], [setPageCount, setErrorFlow]) {
        try {
            const arrayBuffer = await pdf.getContentAsBinary();
            let doc = await PDFJS.getDocument(arrayBuffer).promise;
            setPageCount(doc.numPages);
        } catch (e) {
            setErrorFlow(ErrorFlow.create(e.message, 510));
        }
    }
}

registerBrick('0192dc9c7ff9c4fb270d', GetPDFPagesCount);
